/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["mat-error[_ngcontent-%COMP%]{display:inline-block}mat-form-field[_ngcontent-%COMP%]{width:100%}@media screen and (min-width:500px){ca-role-select[_ngcontent-%COMP%], mat-form-field[_ngcontent-%COMP%]{display:block;width:33%}}"];
export { styles as styles };
